var _excluded = ["children"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { _translate } from "../../../../services/core";
var calendarFc = {
  /**
   * Permet de savoir si on exclus une cellule
   *
   * @param {Date} currentCellDate
   * @param {object} parameters
   * @returns
   */
  isExcluded: function isExcluded(currentCellDate, parameters) {
    var currentCellMonth = currentCellDate.getMonth() + 1;
    var currentCellDay = currentCellDate.getDate();
    var currentCellNumberDay = currentCellDate.getDay();
    var isMonthExist = parameters.days && parameters.days["m".concat(currentCellMonth)];
    if (parameters.min && currentCellDate < parameters.min || parameters.max && currentCellDate > parameters.max || isMonthExist && parameters.days["m".concat(currentCellMonth)].includes(currentCellDay) || parameters.exclude === 'working_week' && currentCellNumberDay >= 1 && currentCellNumberDay <= 5 || parameters.exclude === 'weekend' && (currentCellNumberDay === 0 || currentCellNumberDay === 6)) {
      return true;
    }
    return false;
  },
  /**
   * Traduction des menus
   */
  getMessages: function getMessages() {
    return {
      week: _translate('collectorapp_calendar_week'),
      work_week: _translate('collectorapp_calendar_work_week'),
      day: _translate('collectorapp_calendar_day'),
      month: _translate('collectorapp_calendar_month'),
      previous: _translate('collectorapp_calendar_previous'),
      next: _translate('collectorapp_calendar_next'),
      today: _translate('collectorapp_calendar_today'),
      agenda: _translate('collectorapp_calendar_agenda'),
      showMore: function showMore(total) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, "+", total, " ", _translate('collectorapp_total'));
      }
    };
  },
  /**
   * Créer un composant custom pour chaque cellule
   */
  getComponents: function getComponents(days, exclude, min, max, events) {
    return {
      dateCellWrapper: function dateCellWrapper(_ref) {
        var _children$props;
        var children = _ref.children,
          args = _objectWithoutProperties(_ref, _excluded);
        var className = ((_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.className) || '';
        className += ' c1 c2 ';
        var parameters = {
          days: days,
          exclude: exclude,
          min: min,
          max: max
        };
        if (calendarFc.isExcluded(args.value, parameters)) {
          className += ' disabled';
        }
        if (Array.isArray(events)) {
          events.forEach(function (event) {
            if (event.start.toString() === args.value.toString()) {
              className += ' selected';
            }
          });
        }
        return /*#__PURE__*/React.cloneElement(React.Children.only(children), {
          className: className
        });
      }
    };
  }
};
export default calendarFc;